import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { graphql, StaticQuery } from 'gatsby'
import Cookies from 'js-cookie'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Sprite from '@components/Sprite'
import RichText from '@components/RichText'
import classNames from 'classnames'
import * as editorStyles from '~/styles/components/editor.module.scss'
import * as styles from '../../styles/layout/notices.module.scss'

class Notices extends Component {
  constructor (props) {
    super(props)

    this.cookieName = 'seenNotices'
  }

  close (id) {
    const { hiddenNotices, setHiddenNotices } = this.props
    const newHidden = [...hiddenNotices, id].filter((n, i, a) => a.indexOf(n) === i)

    setHiddenNotices(newHidden)
    Cookies.set(this.cookieName, JSON.stringify(newHidden), { expires: 7 })
  }

  onExit (node) {
    node.style.height = `${node.clientHeight}px`
  }

  render () {
    const { hiddenNotices, integrated } = this.props
    const _render = ({ allContentfulNotice }) => {
      return (
        <TransitionGroup>
          {allContentfulNotice.nodes.filter(notice => hiddenNotices.indexOf(notice.id) === -1).map(notice => (
            <CSSTransition key={notice.id} timeout={300} classNames="fade" onExit={this.onExit.bind(this)}>
              <div className={integrated ? styles.integratedNotice : styles.notice}>
                <div className={classNames('grid-container', integrated && styles.noLeftPadding)}>
                  <div className={classNames(styles.content, 'grid-x grid-margin-x')}>
                    <div className={classNames(styles.row, 'cell auto')}>
                      <div className={classNames(editorStyles.editor, styles.text)}>
                        <RichText json={notice.text.json} />
                      </div>
                    </div>

                    <div className={classNames(styles.row, 'cell shrink')}>
                      <button className={styles.close} type="button" onClick={this.close.bind(this, notice.id)} aria-label="Close">
                        <span className={styles.icon}>
                          <Sprite name="cross" fill={true} />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </CSSTransition>
          ))}
        </TransitionGroup>
      )
    }

    return (
      <StaticQuery query={query} render={_render} />
    )
  }
}

Notices.propTypes = {
  hiddenNotices: PropTypes.arrayOf(PropTypes.string).isRequired,
  integrated: PropTypes.bool,
  setHiddenNotices: PropTypes.func.isRequired
}

Notices.defaultProps = {
  integrated: false
}

const mapStateToProps = (state) => ({
  hiddenNotices: state.global.hiddenNotices
})

const mapDispatchToProps = {
  setHiddenNotices: (hiddenNotices) => ({
    type: 'SET_HIDDEN_NOTICES',
    hiddenNotices
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(Notices)

export const query = graphql`
  query {
    allContentfulNotice(filter: {title: {regex: "/^(?!.*(sample))/gi"}}) {
      nodes {
        id
        text {
          raw
        }
      }
    }
  }
`
